import {nuskin} from '@nuskin/ns-util';

/**
 *
 * newAccount
 *
 * @namespace newAccount
 * @ignore
 */
nuskin.newAccount = {};

export default nuskin.newAccount;
